import React from 'react';
import Typography from '@material-ui/core/Typography';
import WhatIfTreeGridContainer from '../containers/WhatIfTreeGridContainer';
// import Edit from '@material-ui/icons/Edit';
// import Button from 'src/ui/library/Button';
// import Add from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import CurrencyFormat from 'react-currency-format';
import intl from 'react-intl-universal';
import { RadialChart } from 'react-vis';

class WhatIfResultsComparePres extends React.Component {
  render() {
    const {
      selectedResults,
      graphSelected,
      onMouseOver,
      onMouseOut,
      onMouseClick,
      graphData,
      onLeftChevron,
      onRightChevron,
      numEmployees,
    } = this.props;

    return (
      <div className="whatif-results">
        {/* <div className="whatif-results-header">
          <div className="whatif-results-title">{headerTitle}</div>
          {/*<div className="whatif-results-threedotmenu">
            <ThreeDotMenu options={menuOptions} handleMenuSelect={handleMenuSelect} />
    </div>*/}
        {/* </div> */}
        <div className="whatif-results-body">
          <ul className="whatif-results-compare-grid">
            <li className="whatif-results-compare-griditem-chart">
              <Typography className="compare-chart-centerpiece" variant="title" style={{ fontFamily: "'EYInterstate Light', sans-serif" }}>
                <b>{numEmployees}</b> <br /> EMPLOYEES
              </Typography>
              <div className="compare-chart-outer">
                <RadialChart
                  className="compare-chart"
                  animation
                  showLabels={false}
                  onValueMouseOver={onMouseOver}
                  onSeriesMouseOut={onMouseOut}
                  onValueClick={onMouseClick}
                  getAngle={d => d.theta}
                  data={graphData}
                  colorType="literal"
                  width={300}
                  height={350}
                  padAngle={0.0}
                />
                {graphSelected && (
                  <div className="compare-chart-selectmenu" style={{ backgroundColor: graphSelected.color }}>
                    <IconButton id="left-chevron" className="compare-chart-selectmenu-button" onClick={onLeftChevron}>
                      <ChevronLeft />
                    </IconButton>
                    <Typography variant="paragraph" className="compare-chart-selectmenu-centerpiece">
                      <b>{graphSelected.result.classification}</b>
                      <br />
                      <CurrencyFormat
                        value={graphSelected.result.totalCompensationWithEmployees}
                        displayType={'text'}
                        decimalScale={2}
                        thousandSeparator={true}
                        prefix={intl.get('whatif.calculator.currency.prefix')[graphSelected.result.outputCurrency]}
                        suffix={intl.get('whatif.calculator.currency.suffix')[graphSelected.result.outputCurrency]}
                      />
                    </Typography>
                    <IconButton id="right-chevron" className="compare-chart-selectmenu-button" onClick={onRightChevron}>
                      <ChevronRight />
                    </IconButton>
                  </div>
                )}
              </div>
            </li>
            <li className="whatif-results-compare-griditem-table">
              <WhatIfTreeGridContainer data={selectedResults} />
            </li>
          </ul>
        </div>
        {/* <div className="whatif-results-footer">
          <div className="button-wrapper">
            <Button name="initcase" className="action-button submit-button">
              Initiate Case
            </Button>
            <Button name="add" styleType="secondary" className="action-button additional-button" onClick={this.props.onAddEmployees}>
              <Add /> Add Additional Employee
            </Button>
            <Button name="edit" styleType="secondary" className="icon-button action-button" onClick={this.props.handleEdit}>
              <Edit /> Edit
            </Button>
          </div>
        </div> */}
      </div>
    );
  }
}

export default WhatIfResultsComparePres;
